import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=2adffed2&scoped=true&"
import script from "./PriceInput.vue?vue&type=script&lang=js&"
export * from "./PriceInput.vue?vue&type=script&lang=js&"
import style0 from "./PriceInput.vue?vue&type=style&index=0&id=2adffed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adffed2",
  null
  
)

export default component.exports